<script lang="ts">
  import { EditorJs } from 'query-strapi-v4';
  type Block = $$Generic<EditorJs.Delimiter | undefined>;
  // export let block = undefined as Block;
</script>

<hr />
